import HandRaises from './HandRaises';

export default HandRaises;
